import { WorkingHoursStatus } from '../../../../../api/types/lecturers/working-hours/working-hours.type';
import appApi from '../../../../../api/app-api';
import { toast } from 'react-toastify';

export const updateWorkingHoursHoeScreenOperation = async (
  workingHoursId: number,
  workingHoursStatus: WorkingHoursStatus,
  onUpdate: () => any,
) => {
  try {
    await appApi.updateManualWorkingHoursStatus(
      workingHoursId,
      workingHoursStatus,
    );
    onUpdate();
  } catch (e) {
    toast.error('משהו קרה, יש לנסות שוב בעוד מספר רגעים...');
    console.error(
      `updateWorkingHoursHoeScreenOperation is failed with the workingHoursId: ${workingHoursId}, workingHoursStatus: ${workingHoursStatus} and the error: ${e}`,
    );
  }
};
